<template>
    <div>
        <v-card>
              <v-text-field
                class="mx-6"
                readonly
                label="Student ID"
                :rules="rules"
                :value="student.sid"
              ></v-text-field>
              <v-text-field
                class="mx-6"
                :label="'Amount in '+getCurrency"
                :rules="rules"
                v-model="edAmount"
              ></v-text-field>
              <v-select
                class="mx-6"
                v-model="edDescription"
                item-text="name"
                item-value="name"
                :items="categories"
                label="Description"
              ></v-select>

              <DatePickerWithMenu class="mx-4" :default="edDate" label="Billing Date" @date-selected="getSelectedDate"></DatePickerWithMenu>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" dark rounded small @click="saveBilling()">Bill Now</v-btn>
                <v-btn color="primary" dark rounded small @click="showBillingList()">Cancel</v-btn>
              </v-card-actions>
            </v-card>
    </div>
</template>

<script>
import axios from "@/plugins/axios"
import DatePickerWithMenu from '@/components/myLibrary/DatePickerWithMenu.vue';
import targetjs from "./target"

export default {
    name: 'VueElearningRecordFutureBilling',
    props: ['student'],
    components: {
        DatePickerWithMenu
    },
    computed: {
        getCurrency() {
      return this.$store.getters.getCurrency;
      },
      getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    },
    data() {
        return {
            categories:[],
            edAmount: 0,
            edDate: new Date().toISOString().substr(0, 10),
            edDescription: null,
            rules: [value => !!value || "Required!!"],
        };
    },

    async mounted() {
        await this.getAllIncomeCategories()
    },

    methods: {
        getSelectedDate(selectedDate) {
            this.edDate = selectedDate
        },
        async getAllIncomeCategories() {
            this.categories = await targetjs.getAllIncomeCategories()
        },
        showBillingList() {
            this.$emit('show-billing-list')
        },
          saveBilling() {
              this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/save-future-billing",
          {
            sid: this.student.sid,
            student: this.student,
            date: this.edDate,
            amount: this.edAmount,
            description: this.edDescription
          },
          this.getAccessToken
        )
          .then(billings => {
              this.$toast.success('Student Billed Successfully!', { duration: 3000 })
            this.$emit('billing-recorded',billings)
          this.$store.commit("setLoader", false);
        
        });
    }
    },
};
</script>

<style lang="scss" scoped>

</style>